module.exports = __webpack_public_path__ + "static/media/LOGO_COLORES.4fd6db5a.svg";